<template>
  <div class="transfer">
    <v-app>
      <div v-if="!userid">
        <v-container>
          <v-alert :value="true" color="warning" icon="priority_high" outline>
            {{ $t('Not found this page') }}
          </v-alert>
        </v-container>
      </div>
      <div v-else-if="isCompleted">
        <cover>
          <div slot="body" style="text-align: center; margin-top: -95px">
            <img
              src="@/assets/img/ecommerce/shopping_cart@4x.png"
              alt="shopping cart"
              style="width: 140px; padding-bottom: 10px"
            />
            <p style="padding-bottom: 10px">{{ $t('Payment Successfully') }}</p>
            <v-btn outline :color="theme.color" @click="goToShop()">
              {{ $t('Continue Shopping') }}
            </v-btn>
          </div>
        </cover>
      </div>
      <div v-else-if="isEmptyShoppingCart">
        <cover>
          <div slot="body" style="text-align: center; margin-top: -95px">
            <img
              src="@/assets/img/ecommerce/shopping_cart_out@4x.png"
              alt="empty shopping cart"
              style="width: 140px; padding-bottom: 10px"
            />
            <p style="padding-bottom: 10px">
              {{ $t('This order has been reset, please try to order again.') }}
            </p>

            <v-btn outline :color="theme.color" @click="goToShop()">
              {{ $t('Continue Shopping') }}
            </v-btn>
          </div>
        </cover>
      </div>
      <div v-show="!isEmptyShoppingCart && !isCompleted && userid">
        <merchant-detail v-model="pageProfile"></merchant-detail>

        <form
          id="checkout-form"
          class="checkout-form"
          method="POST"
          @submit.prevent="handleSubmit"
        >
          <v-container class="mt-5" style="position: relative">
            <div style="position: absolute; top: -8px; left: 0px">
              <v-btn @click="back" flat
                ><v-icon class="mr-2">mdi-chevron-left</v-icon>Back</v-btn
              >
            </div>
            <v-layout wrap row>
              <v-flex xs12 sm12 offset-sm3 class="text-xs-right">
                <h3 class="headline" :style="{ color: theme.color }">
                  {{ $t('Payment') }}
                </h3>
                <div style="font-weight: bold; font-size: 18px">
                  ที่อยู่สำหรับจัดส่ง
                </div>
                <div>
                  ทีมงานจะจัดส่งของที่ระลึกโดยอ้างอิงจากที่อยู่ในแบบฟอร์มนี้เป็นหลัก
                </div>
                <br />
              </v-flex>
              <v-flex xs12 sm6 offset-sm3>
                <div
                  :class="{ 'has-error': errors.has('customerName') }"
                  class="mb-1"
                >
                  <v-text-field
                    :label="$t('Name')"
                    :data-vv-as="$t('Name')"
                    outline
                    name="customerName"
                    v-validate="'required'"
                    v-model="customerName"
                    light
                    :color="theme.color"
                    :error="errors.has('customerName') ? true : false"
                    :error-messages="
                      errors.has('customerName')
                        ? errors.first('customerName')
                        : ''
                    "
                  ></v-text-field>
                </div>
                <div
                  v-if="isOoca"
                  :class="{ 'has-error': errors.has('emailAddress') }"
                  class="mb-1"
                >
                  <v-text-field
                    outline
                    :label="$t('Email Address')"
                    name="emailAddress"
                    rows="5"
                    :data-vv-as="$t('Email Address')"
                    style="resize: none; width: 100%"
                    v-model="shippingAddress"
                    v-validate="{ required: true, email: true }"
                    light
                    :color="theme.color"
                    :error="errors.has('emailAddress') ? true : false"
                    :error-messages="
                      errors.has('emailAddress')
                        ? errors.first('emailAddress')
                        : ''
                    "
                  ></v-text-field>
                </div>
                <div
                  v-else-if="useOldAddress.includes(pageProfile.pageid)"
                  :class="{ 'has-error': errors.has('shippingAddress') }"
                  class="mb-1"
                >
                  <v-textarea
                    outline
                    :label="$t('Shipping Address')"
                    name="shippingAddress"
                    rows="5"
                    :data-vv-as="$t('Shipping Address')"
                    style="resize: none; width: 100%"
                    v-model="shippingAddress"
                    v-validate="{
                      required: true,
                      regex: /([^0-9][1-9][0-9]{4})|^([1-9][0-9]{4})/,
                      isBearhousezipcode: [cart.length, isBearhouse]
                    }"
                    light
                    :color="theme.color"
                    :error="errors.has('shippingAddress') ? true : false"
                    :error-messages="
                      errors.has('shippingAddress')
                        ? errors.first('shippingAddress')
                        : ''
                    "
                  ></v-textarea>
                </div>
                <template v-else>
                  <div
                    :class="{ 'has-error': errors.has('zipcode') }"
                    class="mb-1"
                  >
                    <thai-address-input
                      v-model="shippingAddress2.zipcode"
                      type="zipcode"
                      @select="onSelectAddress"
                      :label="$t('zipcode')"
                      :data-vv-as="$t('zipcode')"
                      outline
                      name="zipcode"
                      v-validate="'required'"
                      light
                      :color="theme.color"
                      :error="errors.has('zipcode') ? true : false"
                      :error-messages="
                        errors.has('zipcode') ? errors.first('zipcode') : ''
                      "
                    ></thai-address-input>
                  </div>
                  <div
                    :class="{ 'has-error': errors.has('province') }"
                    class="mb-1"
                  >
                    <thai-address-input
                      v-model="shippingAddress2.province"
                      type="province"
                      @select="onSelectAddress"
                      :label="$t('province')"
                      :data-vv-as="$t('province')"
                      outline
                      name="province"
                      v-validate="'required'"
                      light
                      :color="theme.color"
                      :error="errors.has('province') ? true : false"
                      :error-messages="
                        errors.has('province') ? errors.first('province') : ''
                      "
                    ></thai-address-input>
                  </div>
                  <div
                    :class="{ 'has-error': errors.has('amphoe') }"
                    class="mb-1"
                  >
                    <thai-address-input
                      v-model="shippingAddress2.district"
                      type="amphoe"
                      @select="onSelectAddress"
                      :label="$t('amphoe')"
                      :data-vv-as="$t('amphoe')"
                      outline
                      name="amphoe"
                      v-validate="'required'"
                      light
                      :color="theme.color"
                      :error="errors.has('amphoe') ? true : false"
                      :error-messages="
                        errors.has('amphoe') ? errors.first('amphoe') : ''
                      "
                    ></thai-address-input>
                  </div>
                  <div
                    :class="{ 'has-error': errors.has('district') }"
                    class="mb-1"
                  >
                    <thai-address-input
                      v-model="shippingAddress2.sub_district"
                      type="district"
                      @select="onSelectAddress"
                      :label="$t('district')"
                      :data-vv-as="$t('district')"
                      outline
                      name="district"
                      v-validate="'required'"
                      light
                      :color="theme.color"
                      :error="errors.has('district') ? true : false"
                      :error-messages="
                        errors.has('district') ? errors.first('district') : ''
                      "
                    ></thai-address-input>
                  </div>
                  <div
                    :class="{ 'has-error': errors.has('shippingAddress') }"
                    class="mb-1"
                  >
                    <v-textarea
                      outline
                      :label="$t('Shipping Address')"
                      name="shippingAddress"
                      rows="5"
                      :data-vv-as="$t('Shipping Address')"
                      style="resize: none; width: 100%"
                      v-model="shippingAddress"
                      :placeholder="
                        $t('Ex. Address No., Village, Alley, and Road') +
                        (pageProfile.type == 'constructpage'
                          ? ` จุดสังเกตใกล้เคียง`
                          : '')
                      "
                      v-validate="{
                        required: true
                      }"
                      light
                      :color="theme.color"
                      :error="errors.has('shippingAddress') ? true : false"
                      :error-messages="
                        errors.has('shippingAddress')
                          ? errors.first('shippingAddress')
                          : ''
                      "
                    ></v-textarea>
                  </div>
                </template>
                <div style="clear: both"></div>

                <div
                  v-if="$store.state.cds.includes(pageid)"
                  :class="{ 'has-error': errors.has('remark') }"
                >
                  <v-text-field
                    outline
                    :label="$t('The 1 Card Number') + ` (${$t('Optional')})`"
                    name="remark"
                    :data-vv-as="$t('The 1 Card Number')"
                    style="resize: none; width: 100%"
                    v-model="remark"
                    :color="theme.color"
                    light
                  ></v-text-field>
                </div>

                <div
                  :class="{ 'has-error': errors.has('customerPhone') }"
                  class="mb-1"
                >
                  <v-text-field
                    :label="$t('Tel.')"
                    :data-vv-as="$t('Tel.')"
                    outline
                    tyle="tel"
                    name="customerPhone"
                    light
                    :color="theme.color"
                    v-validate="{
                      required: true,
                      regex:
                        /((\(?(\+\s*)([0-9]{2,3})\)?\s*[0]?)|[0])(([1-9][0-9]?))\s*\-?\s*([0-9]{3})\s*\-?\s*([0-9]{4,5})/
                    }"
                    v-model="customerPhone"
                    :error="errors.has('customerPhone') ? true : false"
                    :error-messages="
                      errors.has('customerPhone')
                        ? errors.first('customerPhone')
                        : ''
                    "
                  ></v-text-field>
                </div>
                <template v-if="pageProfile.type == 'nvbb' && hasOtherProduct">
                  <div :style="{ color: theme.color }">
                    **** สินค้าบางชนิดไม่ได้อยู่ในแพคเกจกรุณาเลือกวิธีจัดส่ง
                  </div>
                  <v-radio-group
                    v-model="hasShippingNow"
                    row
                    @change="changeHasShippingNow"
                  >
                    <v-radio
                      :label="`จัดส่งพร้อมกับแพคเกจ`"
                      :value="false"
                      :color="theme.color"
                    ></v-radio>
                    <v-radio
                      :label="`จัดส่งทันที  (มีค่าส่งเพิ่มเติม)`"
                      :value="true"
                      :color="theme.color"
                    ></v-radio>
                  </v-radio-group>
                </template>
                <template v-if="pageProfile.type == 'nvbb' && hasShippingNow">
                  <shipping-type
                    v-model="shippingType"
                    @onChange="changeShippingType"
                    :shippinglist="nvbbshippinglist"
                    :additionalproduct_charge="additionalproduct_charge"
                    :pageid="pageProfile.pageid"
                    :total="totalincludediscount"
                  ></shipping-type>
                </template>

                <template
                  v-if="
                    pageProfile &&
                    pageProfile.pageid &&
                    shippinglist &&
                    !isOoca &&
                    pageProfile.type != 'nvbb'
                  "
                >
                  <shipping-type
                    :bearhouseshippingprice="bearhouseshippingprice"
                    :cdsshippingprice="cdsshippingprice"
                    v-model="shippingType"
                    @onChange="changeShippingType"
                    :shippinglist="shippinglist"
                    :additionalproduct_charge="additionalproduct_charge"
                    :pageid="pageProfile.pageid"
                    :total="totalincludediscount"
                  ></shipping-type>
                </template>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
          <v-container class="mt-3">
            <v-layout wrap row>
              <v-flex xs12 sm6 offset-sm3>
                <h3
                  class="headline mb-3 text-xs-center"
                  :style="{ color: theme.color }"
                >
                  {{ $t('Payment Detail') }}
                </h3>

                <cart-summary
                  :cdsshippingprice="cdsshippingprice"
                  :bearhouseshippingprice="bearhouseshippingprice"
                  :total="total"
                  :totalincludediscount="totalincludediscount"
                  :discount="discount"
                  :voucher="voucher"
                  :shippingType="shippingType"
                  :additionalproduct_charge="additionalproduct_charge"
                ></cart-summary>

                <template
                  v-if="
                    !loading &&
                    hasVoucher &&
                    !['485851741439218'].includes(pageProfile.pageid)
                  "
                >
                  <voucher-code-input
                    v-model="voucherCode"
                    @onUpdateTotal="onUpdateTotal"
                  ></voucher-code-input>
                </template>

                <div
                  v-if="!$store.state.cds.includes(pageid)"
                  :class="{ 'has-error': errors.has('remark') }"
                  style="margin-bottom: 15px"
                >
                  <v-textarea
                    outline
                    :label="$t('Remark')"
                    name="remark"
                    rows="5"
                    :data-vv-as="$t('Remark')"
                    style="resize: none; width: 100%"
                    v-model="remark"
                    :color="theme.color"
                    light
                  ></v-textarea>
                </div>
                <div>
                  <div style="padding-bottom: 25px">
                    <v-card>
                      <v-card-text>
                        <div>
                          <v-layout row wrap class="mb-3">
                            <v-flex
                              :xs6="paymentList.length > 1"
                              :xs12="paymentList.length == 1"
                              class="px-1"
                              v-if="paymentList.includes('gbprime')"
                            >
                              <h3
                                v-if="paymentList.length == 1"
                                class="text-xs-center"
                              >
                                <v-icon small class="mr-2"
                                  >mdi-qrcode-scan</v-icon
                                >
                                <b>QR CODE</b>
                              </h3>
                              <v-btn
                                v-else
                                :color="theme.color"
                                dark
                                block
                                small
                                @click="
                                  transferType = 'qrcode'
                                  setShippingDefault()
                                "
                                :outline="transferType != 'qrcode'"
                              >
                                <v-icon small class="mr-2"
                                  >mdi-qrcode-scan</v-icon
                                >QR CODE
                              </v-btn>
                            </v-flex>
                            <v-flex
                              :xs6="paymentList.length > 1"
                              :xs12="paymentList.length == 1"
                              class="px-1"
                              v-if="paymentList.includes('transfer')"
                            >
                              <template v-if="paymentList.length == 1">
                                <h3 class="text-xs-center">
                                  {{ $t('transfer') }}
                                </h3>
                              </template>
                              <template v-else>
                                <v-btn
                                  v-if="!showOnlyQRpage"
                                  :color="theme.color"
                                  dark
                                  block
                                  small
                                  @click="
                                    transferType = 'transfer'
                                    setShippingDefault()
                                  "
                                  :outline="transferType != 'transfer'"
                                >
                                  <v-icon small class="mr-2"
                                    >mdi-cash-multiple</v-icon
                                  >
                                  {{ $t('transfer') }}
                                </v-btn>
                              </template>
                            </v-flex>
                            <v-flex
                              :xs6="paymentList.length > 1"
                              :xs12="paymentList.length == 1"
                              class="px-1"
                              v-if="paymentList.includes('2c2p')"
                            >
                              <v-btn
                                :color="theme.color"
                                dark
                                small
                                block
                                v-if="$store.state.page2c2p.includes(pageid)"
                                @click="
                                  transferType = '2c2p'
                                  setShippingDefault()
                                "
                                :outline="transferType != '2c2p'"
                              >
                                <template>
                                  <v-icon small class="mr-2"
                                    >mdi-credit-card</v-icon
                                  >
                                  {{
                                    $t(
                                      [
                                        '104716585038207',
                                        '362065616073'
                                      ].includes(pageProfile.pageid)
                                        ? 'Credit Cards'
                                        : '2C2P Payment'
                                    )
                                  }}
                                </template>
                              </v-btn>
                              <v-btn
                                :color="theme.color"
                                dark
                                small
                                block
                                v-else-if="$store.state.cds.includes(pageid)"
                                @click="
                                  transferType = 'fbpay'
                                  setShippingDefault()
                                "
                                :outline="transferType != 'fbpay'"
                              >
                                <template>
                                  <v-icon small class="mr-2"
                                    >mdi-credit-card</v-icon
                                  >
                                  {{ $t('Credit Cards') }}
                                </template>
                              </v-btn>
                            </v-flex>
                            <v-flex
                              :xs6="paymentList.length > 1"
                              :xs12="paymentList.length == 1"
                              class="px-1"
                              v-if="paymentList.includes('fbpay')"
                            >
                              <v-btn
                                :color="theme.color"
                                dark
                                small
                                block
                                @click="
                                  transferType = 'fbpay'
                                  setShippingDefault()
                                "
                                :outline="transferType != 'fbpay'"
                              >
                                <template>
                                  <v-icon small class="mr-2"
                                    >mdi-cellphone-android</v-icon
                                  >
                                  {{ $t('Mobile Banking') }}
                                </template>
                              </v-btn>
                            </v-flex>
                            <v-flex
                              :xs6="paymentList.length > 1"
                              :xs12="paymentList.length == 1"
                              class="px-1"
                              v-if="paymentList.includes('cod')"
                            >
                              <template v-if="paymentList.length == 1">
                                <h3 class="text-xs-center">
                                  {{ $t('cod_charge') }}
                                </h3>
                              </template>
                              <v-btn
                                v-else
                                :color="theme.color"
                                dark
                                small
                                block
                                @click="
                                  transferType = 'cod_charge'
                                  setShippingDefault('cod_charge')
                                "
                                :outline="transferType != 'cod_charge'"
                              >
                                <v-icon small class="mr-2"
                                  >mdi-package-variant-closed</v-icon
                                >
                                {{ $t('cod_charge') }}
                              </v-btn>
                            </v-flex>
                            <v-flex
                              :xs6="paymentList.length > 1"
                              :xs12="paymentList.length == 1"
                              v-if="paymentList.includes('paypal')"
                              class="px-1"
                            >
                              <v-btn
                                :color="theme.color"
                                dark
                                block
                                small
                                @click="
                                  transferType = 'paypal'
                                  renderPaypalBtn()
                                  setShippingDefault()
                                "
                                :outline="transferType != 'paypal'"
                              >
                                <v-icon small class="mr-2"
                                  >mdi-credit-card</v-icon
                                >
                                {{ $t('PayPal') }}
                              </v-btn>
                            </v-flex>

                            <v-flex
                              :xs6="paymentList.length > 1"
                              :xs12="paymentList.length == 1"
                              class="px-1"
                              v-if="paymentList.includes('creditgbprime')"
                            >
                              <v-btn
                                :color="theme.color"
                                dark
                                small
                                block
                                @click="
                                  transferType = 'creditgbprime'
                                  setShippingDefault()
                                "
                                :outline="transferType != 'creditgbprime'"
                              >
                                <template>
                                  <v-icon small class="mr-2"
                                    >mdi-credit-card</v-icon
                                  >
                                  {{ $t('Credit Cards') }}
                                </template>
                              </v-btn>
                            </v-flex>
                          </v-layout>

                          <!-- Cash on Delivery -->
                          <template
                            v-if="
                              shippingType && shippingType.type == 'cod_charge'
                            "
                          >
                            <div
                              class="text-xs-center"
                              style="padding-top: 15px; padding-bottom: 15px"
                            >
                              <a
                                href="javascript:void(0);"
                                @click="openModal()"
                                style="color: rgb(169, 169, 169)"
                              >
                                {{
                                  $t(
                                    'By clicking Proceed Payment, Ive read and'
                                  )
                                }}
                                <br />
                                {{ $t('agree to') }}
                                <span :style="{ color: theme.color }">
                                  {{
                                    $t('Terms & Condition & Refund Prolicy')
                                  }} </span
                                >.
                              </a>
                            </div>
                            <template v-if="loading">
                              <div class="text-xs-center my-3">
                                <v-progress-circular
                                  :key="theme.color"
                                  indeterminate
                                  :color="theme.color"
                                ></v-progress-circular>
                              </div>
                            </template>
                            <template v-else>
                              <p
                                class="text-xs-center"
                                style="color: red"
                                v-if="isCartOutOfStock"
                              >
                                {{
                                  $t(
                                    'Not enough products in stock, please try to order again.'
                                  )
                                }}.
                              </p>
                              <div class="text-xs-center">
                                <v-btn
                                  dark
                                  :color="theme.color"
                                  :disabled="loading || isCartOutOfStock"
                                  @click="handleSubmit"
                                  :loading="pageLoading"
                                >
                                  <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                  {{ $t('Proceed Payment') }}
                                </v-btn>
                              </div>
                            </template>
                          </template>

                          <template
                            v-else-if="
                              ['transfer', 'fbpay'].includes(transferType)
                            "
                          >
                            <div v-if="['transfer'].includes(transferType)">
                              <div class="mb-4">
                                <template v-if="banktransferinfo_photo">
                                  <img
                                    :src="banktransferinfo_photo"
                                    alt="bank transfer"
                                    style="
                                      border: 1px solid #eee;
                                      border-radius: 5px;
                                      margin-bottom: 15px;
                                      width: 100%;
                                    "
                                  />
                                </template>
                                <template v-if="banktransferinfo">
                                  <bank-number
                                    :text="banktransferinfo"
                                  ></bank-number>
                                </template>
                              </div>

                              <div
                                :class="{
                                  'has-error': errors.has('paymentSlipImage')
                                }"
                                class="mb-4"
                                v-if="
                                  !shippingType ||
                                  (shippingType &&
                                    shippingType.type != 'cod_charge')
                                "
                              >
                                <h3
                                  class="headline"
                                  :style="{ color: theme.color }"
                                >
                                  {{ $t('Payment slip') }}
                                </h3>
                                <br />
                                <template v-if="!isCartOutOfStock">
                                  <upload-file
                                    :outputtype="
                                      isCDS || pageProfile.type == 'monobo'
                                        ? 'base64'
                                        : 'url'
                                    "
                                    name="paymentSlipImage"
                                    v-validate="'required'"
                                    :data-vv-as="$t('Payment Slip Image')"
                                    v-model="paymentSlipImage"
                                  ></upload-file>
                                </template>
                                <p
                                  class="caption ma-2"
                                  style="color: red"
                                  v-show="errors.has('paymentSlipImage')"
                                >
                                  {{ errors.first('paymentSlipImage') }}
                                </p>
                              </div>

                              <div
                                v-if="pageProfile.type == 'monobo'"
                                :class="{ 'has-error': errors.has('bankname') }"
                                style="margin-bottom: 15px"
                              >
                                <v-select
                                  v-model="bankname"
                                  outline
                                  label="บัญชีที่ลูกค้าทำการชำระ"
                                  key="บัญชี"
                                  data-vv-as="บัญชีที่ลูกค้าทำการชำระ"
                                  v-validate="'required'"
                                  :items="monobobanklist"
                                  name="bankname"
                                  :error="errors.has('bankname') ? true : false"
                                  :error-messages="
                                    errors.has('bankname')
                                      ? errors.first('bankname')
                                      : ''
                                  "
                                ></v-select>
                                <!-- <v-textarea
                                  outline
                                  :label="$t('Remark')"
                                  name="remark"
                                  rows="5"
                                  :data-vv-as="$t('Remark')"
                                  style="resize: none;width:100%"
                                  v-model="remark"
                                  :color="theme.color"
                                  light
                                ></v-textarea>-->
                              </div>
                            </div>
                            <div
                              class="text-xs-center"
                              style="padding-top: 15px; padding-bottom: 15px"
                            >
                              <a
                                href="javascript:void(0);"
                                @click="openModal()"
                                style="color: rgb(169, 169, 169)"
                              >
                                {{
                                  $t(
                                    'By clicking Proceed Payment, Ive read and'
                                  )
                                }}
                                <br />
                                {{ $t('agree to') }}
                                <span :style="{ color: theme.color }">
                                  {{
                                    $t('Terms & Condition & Refund Prolicy')
                                  }} </span
                                >.
                              </a>
                            </div>
                            <template v-if="loading">
                              <div class="text-xs-center my-3">
                                <v-progress-circular
                                  :key="theme.color"
                                  indeterminate
                                  :color="theme.color"
                                ></v-progress-circular>
                              </div>
                            </template>
                            <template v-else>
                              <p
                                class="text-xs-center"
                                style="color: red"
                                v-if="isCartOutOfStock"
                              >
                                {{
                                  $t(
                                    'Not enough products in stock, please try to order again.'
                                  )
                                }}.
                              </p>
                              <div class="text-xs-center">
                                <v-btn
                                  dark
                                  :color="theme.color"
                                  :disabled="loading || isCartOutOfStock"
                                  @click="handleSubmit"
                                  :loading="pageLoading"
                                >
                                  <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                  {{ $t('Proceed Payment') }}
                                </v-btn>
                              </div>
                            </template>
                          </template>
                          <template v-else-if="['2c2p'].includes(transferType)">
                            <template
                              v-if="
                                ['104716585038207', '362065616073'].includes(
                                  pageProfile.pageid
                                )
                              "
                            >
                              <form
                                ref="form2c2p"
                                id="2c2p-payment-form"
                                method="POST"
                                :action="`https://2c2pgateway.zwiz.ai/indexzwiz.php?date=${new Date()}`"
                              >
                                <input
                                  type="hidden"
                                  v-model="orderid"
                                  name="orderid"
                                />
                                <input
                                  type="hidden"
                                  v-model="amount"
                                  name="amount"
                                />
                                <input type="hidden" value="bec" name="theme" />
                                <input
                                  type="hidden"
                                  :value="pageProfile.pageid"
                                  name="pageid"
                                />
                                <input
                                  type="hidden"
                                  v-model="serverUrl"
                                  name="serverUrl"
                                />
                                <input
                                  type="hidden"
                                  :value="payment_option"
                                  name="payment_option"
                                />
                              </form>
                            </template>

                            <div v-else>
                              <v-card>
                                <v-card-text>
                                  <form
                                    @submit="submit2c2p"
                                    ref="form2c2p"
                                    id="2c2p-payment-form"
                                    method="POST"
                                    :action="`https://2c2pgateway.zwiz.ai/index.php?${new Date()}`"
                                  >
                                    <div
                                      :class="{
                                        'has-error':
                                          errors.has('Cardholdername')
                                      }"
                                      class="mb-1"
                                    >
                                      <v-text-field
                                        name="Cardholdername"
                                        :data-vv-as="$t('Cardholder Name')"
                                        label="Cardholder Name"
                                        :color="theme.color"
                                        v-model="creditcard.name"
                                        placeholder=" "
                                        v-validate="'required'"
                                        :error="
                                          errors.has('Cardholdername')
                                            ? true
                                            : false
                                        "
                                        :error-messages="
                                          errors.has('Cardholdername')
                                            ? errors.first('Cardholdername')
                                            : ''
                                        "
                                      ></v-text-field>
                                    </div>
                                    <div
                                      :class="{
                                        'has-error': errors.has('cardnumber')
                                      }"
                                      class="mb-1"
                                    >
                                      <v-text-field
                                        data-encrypt="cardnumber"
                                        name="cardnumber"
                                        label="Card Number"
                                        placeholder=" "
                                        v-validate="'required'"
                                        :error="
                                          errors.has('cardnumber')
                                            ? true
                                            : false
                                        "
                                        :error-messages="
                                          errors.has('cardnumber')
                                            ? errors.first('cardnumber')
                                            : ''
                                        "
                                        :color="theme.color"
                                        v-model="creditcard.number"
                                      ></v-text-field>
                                    </div>
                                    <v-layout>
                                      <v-flex xs6>
                                        <div
                                          class="form-control"
                                          :class="{
                                            'has-error':
                                              errors.has('month') ||
                                              errors.has('year')
                                          }"
                                        >
                                          <v-text-field
                                            label="Expire date"
                                            v-themask="'##/##'"
                                            :masked="true"
                                            :error="
                                              errors.has('month') ||
                                              errors.has('year')
                                            "
                                            :error-messages="
                                              errors.has('month')
                                                ? errors.first('month')
                                                : errors.has('year')
                                                ? errors.first('month')
                                                : ''
                                            "
                                            placeholder="MM/YY"
                                            :color="theme.color"
                                            @input="onChangeExpireDate"
                                            v-model="creditcard.validate"
                                          />

                                          <v-text-field
                                            data-encrypt="month"
                                            name="month"
                                            :data-vv-as="'Month'"
                                            style="width: 0; height: 0"
                                            v-validate="'required'"
                                            readonly
                                            class="pa-0"
                                            v-model="creditcard.expiremonth"
                                          />
                                          <v-text-field
                                            name="year"
                                            data-encrypt="year"
                                            class="pa-0"
                                            :data-vv-as="'Year'"
                                            v-validate="'required'"
                                            style="
                                              visibility: hidden;
                                              width: 0;
                                              height: 0;
                                            "
                                            readonly
                                            v-model="creditcard.expireyear"
                                          />
                                        </div>
                                      </v-flex>
                                      <v-flex xs6>
                                        <div
                                          :class="{
                                            'has-error': errors.has('cvv')
                                          }"
                                        >
                                          <v-text-field
                                            label="CVV/CVV2"
                                            v-validate="'required'"
                                            :data-vv-as="'CVV/CVV2'"
                                            data-encrypt="cvv"
                                            name="cvv"
                                            v-themask="['###', '####']"
                                            placeholder=" "
                                            :color="theme.color"
                                            v-model="creditcard.cvv"
                                            :error="
                                              errors.has('cvv') ? true : false
                                            "
                                            :error-messages="
                                              errors.has('cvv')
                                                ? errors.first('cvv')
                                                : ''
                                            "
                                          />
                                        </div>
                                      </v-flex>
                                    </v-layout>
                                    <input
                                      type="hidden"
                                      v-model="orderid"
                                      name="orderid"
                                    />
                                    <input
                                      type="hidden"
                                      v-model="amount"
                                      name="amount"
                                    />
                                    <input
                                      type="hidden"
                                      v-model="facebookname"
                                      name="facebookname"
                                    />
                                    <input
                                      type="hidden"
                                      v-model="pageid"
                                      name="pageid"
                                    />
                                  </form>
                                </v-card-text>
                                <div class="pb-3 text-xs-center">
                                  <img
                                    width="120px"
                                    src="@/assets/img/creditcardlogo.png"
                                  />
                                </div>
                              </v-card>
                            </div>
                            <div
                              class="text-xs-center"
                              style="padding-top: 15px; padding-bottom: 15px"
                            >
                              <a
                                href="javascript:void(0);"
                                @click="openModal()"
                                style="color: rgb(169, 169, 169)"
                              >
                                {{
                                  $t(
                                    'By clicking Proceed Payment, Ive read and'
                                  )
                                }}
                                <br />
                                {{ $t('agree to') }}
                                <span :style="{ color: theme.color }">
                                  {{
                                    $t('Terms & Condition & Refund Prolicy')
                                  }} </span
                                >.
                              </a>
                            </div>
                            <template v-if="loading">
                              <div class="text-xs-center my-3">
                                <v-progress-circular
                                  :key="theme.color"
                                  indeterminate
                                  :color="theme.color"
                                ></v-progress-circular>
                              </div>
                            </template>

                            <template v-else>
                              <p
                                class="text-xs-center"
                                style="color: red"
                                v-if="isCartOutOfStock"
                              >
                                {{
                                  $t(
                                    'Not enough products in stock, please try to order again.'
                                  )
                                }}.
                              </p>
                              <div class="text-xs-center">
                                <v-btn
                                  v-if="isCDS && transferType == '2c2p'"
                                  dark
                                  :color="theme.color"
                                  :disabled="loading || isCartOutOfStock"
                                  @click="handleSubmit"
                                  :loading="pageLoading"
                                >
                                  <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                  {{ $t('Proceed Payment') }}
                                </v-btn>
                                <v-btn
                                  dark
                                  v-else
                                  :color="theme.color"
                                  :disabled="loading || isCartOutOfStock"
                                  @click="handleSubmit"
                                  :loading="pageLoading"
                                >
                                  <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                  {{ $t('Proceed Payment') }}
                                </v-btn>
                              </div>
                            </template>
                          </template>
                          <template
                            v-else-if="['creditgbprime'].includes(transferType)"
                          >
                            <div>
                              <v-card class="elevation-0">
                                <v-card-text>
                                  <form
                                    ref="form-gbcredit"
                                    id="gbcredit-payment-form"
                                    method="POST"
                                  >
                                    <div
                                      :class="{
                                        'has-error':
                                          errors.has('Cardholdername')
                                      }"
                                      class="mb-1"
                                    >
                                      <v-text-field
                                        name="Cardholdername"
                                        :data-vv-as="$t('Cardholder Name')"
                                        label="Cardholder Name"
                                        :color="theme.color"
                                        v-model="creditcard.name"
                                        maxlength="120"
                                        placeholder=" "
                                        v-validate="'required'"
                                        :error="
                                          errors.has('Cardholdername')
                                            ? true
                                            : false
                                        "
                                        :error-messages="
                                          errors.has('Cardholdername')
                                            ? errors.first('Cardholdername')
                                            : ''
                                        "
                                      ></v-text-field>
                                    </div>
                                    <div
                                      :class="{
                                        'has-error': errors.has('cardnumber')
                                      }"
                                      class="mb-1"
                                    >
                                      <v-text-field
                                        data-encrypt="cardnumber"
                                        name="cardnumber"
                                        v-themask="'#### #### #### #### ###'"
                                        label="Card Number"
                                        placeholder=" "
                                        v-validate="'required|credit_card'"
                                        :error="
                                          errors.has('cardnumber')
                                            ? true
                                            : false
                                        "
                                        :error-messages="
                                          errors.has('cardnumber')
                                            ? errors.first('cardnumber')
                                            : ''
                                        "
                                        :color="theme.color"
                                        v-model="creditcard.number"
                                      ></v-text-field>
                                    </div>
                                    <v-layout>
                                      <v-flex xs6 class="pr-1">
                                        <div
                                          class="form-control"
                                          :class="{
                                            'has-error':
                                              errors.has('month') ||
                                              errors.has('year')
                                          }"
                                        >
                                          <v-text-field
                                            label="Expire date"
                                            v-themask="'##/##'"
                                            :masked="true"
                                            :error="
                                              errors.has('month') ||
                                              errors.has('year')
                                            "
                                            :error-messages="
                                              errors.has('month')
                                                ? errors.first('month')
                                                : errors.has('year')
                                                ? errors.first('month')
                                                : ''
                                            "
                                            placeholder="MM/YY"
                                            :color="theme.color"
                                            @input="onChangeExpireDate"
                                            v-model="creditcard.validate"
                                          />

                                          <v-text-field
                                            data-encrypt="month"
                                            name="month"
                                            :data-vv-as="'Month'"
                                            style="width: 0; height: 0"
                                            v-validate="'required'"
                                            readonly
                                            class="pa-0"
                                            v-model="creditcard.expiremonth"
                                          />
                                          <v-text-field
                                            name="year"
                                            data-encrypt="year"
                                            class="pa-0"
                                            :data-vv-as="'Year'"
                                            v-validate="'required'"
                                            style="
                                              visibility: hidden;
                                              width: 0;
                                              height: 0;
                                            "
                                            readonly
                                            v-model="creditcard.expireyear"
                                          />
                                        </div>
                                      </v-flex>
                                      <v-flex xs6 class="pl-1">
                                        <div
                                          :class="{
                                            'has-error': errors.has('cvv')
                                          }"
                                        >
                                          <v-text-field
                                            label="CVV/CVV2"
                                            v-validate="'required'"
                                            :data-vv-as="'CVV/CVV2'"
                                            data-encrypt="cvv"
                                            name="cvv"
                                            v-themask="['###', '####']"
                                            placeholder=" "
                                            :color="theme.color"
                                            v-model="creditcard.cvv"
                                            :error="
                                              errors.has('cvv') ? true : false
                                            "
                                            :error-messages="
                                              errors.has('cvv')
                                                ? errors.first('cvv')
                                                : ''
                                            "
                                          />
                                        </div>
                                      </v-flex>
                                    </v-layout>
                                    <input
                                      type="hidden"
                                      v-model="orderid"
                                      name="orderid"
                                    />
                                    <input
                                      type="hidden"
                                      v-model="amount"
                                      name="amount"
                                    />
                                    <input
                                      type="hidden"
                                      v-model="facebookname"
                                      name="facebookname"
                                    />
                                    <input
                                      type="hidden"
                                      v-model="pageid"
                                      name="pageid"
                                    />
                                  </form>
                                </v-card-text>
                                <div class="pb-3 text-xs-center">
                                  <img
                                    width="120px"
                                    src="@/assets/img/creditcardlogo.png"
                                  />
                                </div>
                              </v-card>
                            </div>
                            <div
                              class="text-xs-center"
                              style="padding-top: 15px; padding-bottom: 15px"
                            >
                              <a
                                href="javascript:void(0);"
                                @click="openModal()"
                                style="color: rgb(169, 169, 169)"
                              >
                                {{
                                  $t(
                                    'By clicking Proceed Payment, Ive read and'
                                  )
                                }}
                                <br />
                                {{ $t('agree to') }}
                                <span :style="{ color: theme.color }">
                                  {{
                                    $t('Terms & Condition & Refund Prolicy')
                                  }} </span
                                >.
                              </a>
                            </div>
                            <template v-if="loading">
                              <div class="text-xs-center my-3">
                                <v-progress-circular
                                  :key="theme.color"
                                  indeterminate
                                  :color="theme.color"
                                ></v-progress-circular>
                              </div>
                            </template>

                            <template v-else>
                              <p
                                class="text-xs-center"
                                style="color: red"
                                v-if="isCartOutOfStock"
                              >
                                {{
                                  $t(
                                    'Not enough products in stock, please try to order again.'
                                  )
                                }}.
                              </p>
                              <div class="text-xs-center">
                                <v-btn
                                  dark
                                  :color="theme.color"
                                  :disabled="loading || isCartOutOfStock"
                                  @click="gbcreditSubmit"
                                  :loading="pageLoading"
                                >
                                  <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                  {{ $t('Proceed Payment') }}
                                </v-btn>
                              </div>
                            </template>
                          </template>
                          <template
                            v-else-if="['qrcode'].includes(transferType)"
                          >
                            <div
                              class="text-xs-center"
                              style="padding-top: 15px; padding-bottom: 15px"
                            >
                              <a
                                href="javascript:void(0);"
                                @click="openModal()"
                                style="color: rgb(169, 169, 169)"
                              >
                                {{
                                  $t(
                                    'By clicking Proceed Payment, Ive read and'
                                  )
                                }}
                                <br />
                                {{ $t('agree to') }}
                                <span :style="{ color: theme.color }">
                                  {{
                                    $t('Terms & Condition & Refund Prolicy')
                                  }} </span
                                >.
                              </a>
                            </div>

                            <template v-if="loading">
                              <div class="text-xs-center my-3">
                                <v-progress-circular
                                  :key="theme.color"
                                  indeterminate
                                  :color="theme.color"
                                ></v-progress-circular>
                              </div>
                            </template>
                            <template v-else>
                              <p
                                class="text-xs-center"
                                style="color: red"
                                v-if="isCartOutOfStock"
                              >
                                {{
                                  $t(
                                    'Not enough products in stock, please try to order again.'
                                  )
                                }}.
                              </p>
                              <div class="text-xs-center">
                                <v-btn
                                  dark
                                  :color="theme.color"
                                  :disabled="loading || isCartOutOfStock"
                                  @click="qrHandleSubmit"
                                  :loading="pageLoading || loadingQrcode"
                                >
                                  <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                  {{ $t('Proceed Payment') }}
                                </v-btn>
                              </div>
                            </template>
                          </template>
                          <div v-show="['paypal'].includes(transferType)">
                            <div
                              class="text-xs-center"
                              style="padding-top: 15px; padding-bottom: 15px"
                            >
                              <a
                                href="javascript:void(0);"
                                @click="openModal()"
                                style="color: rgb(169, 169, 169)"
                              >
                                {{
                                  $t(
                                    'By clicking Proceed Payment, Ive read and'
                                  )
                                }}
                                <br />
                                {{ $t('agree to') }}
                                <span :style="{ color: theme.color }">
                                  {{
                                    $t('Terms & Condition & Refund Prolicy')
                                  }} </span
                                >.
                              </a>
                            </div>

                            <template v-if="loading">
                              <div class="text-xs-center my-3">
                                <v-progress-circular
                                  :key="theme.color"
                                  indeterminate
                                  :color="theme.color"
                                ></v-progress-circular>
                              </div>
                            </template>
                            <div v-show="!loading">
                              <p
                                class="text-xs-center"
                                style="color: red"
                                v-if="isCartOutOfStock"
                              >
                                {{
                                  $t(
                                    'Not enough products in stock, please try to order again.'
                                  )
                                }}.
                              </p>
                              <div
                                ref="paypal-button-container"
                                class="text-xs-center"
                                v-show="!isCartOutOfStock"
                              >
                                <div id="paypal-button"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </div>
    </v-app>
    <Loading v-if="!pageLoading && loading"></Loading>
    <term-and-condition
      :pageid="pageProfile.pageid"
      v-if="showTerm"
      @close="close()"
    ></term-and-condition>
    <v-dialog v-model="showQrCode" max-width="376" persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="closeQrCode">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <template v-if="qrimage">
            <img :src="qrimage" style="width: 100%" />
            <div class="text-xs-center mt-2">
              {{
                $t(
                  'If you already have proceeded a payment, you may close this popup window.'
                )
              }}
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <template v-if="gbcharge">
      <form
        ref="gbchargeform"
        name="form"
        :action="`${gbpath}/v1/tokens/3d_secured`"
        method="POST"
      >
        publicKey:
        <input type="text" name="publicKey" :value="gbpublickey" /><br />
        gbpReferenceNo:
        <input
          type="text"
          name="gbpReferenceNo"
          :value="gbcharge.gbpReferenceNo"
        />
      </form>
    </template>
  </div>
</template>

<script>
import MainTransfer from './MainTransfer'
export default {
  mixins: [MainTransfer],
  methods: {
    back() {
      this.$store.state.view = 'ecommerce'
    }
  }
}
</script>
